import { Injectable } from '@angular/core';
import { EnumDetail } from '../model';
import { BaseService } from '../../shared/baseService';

@Injectable({
    providedIn: 'root'
})

export class EnumDetailsService extends BaseService<EnumDetail> {
    constructor() {
        super('EnumDetail');
    }
}
